
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d)"}},[_c('path',{attrs:{"d":"M37.75 19c0 8.698-7.052 15.75-15.75 15.75S6.25 27.698 6.25 19 13.302 3.25 22 3.25 37.75 10.302 37.75 19z","fill":"#fff"}})]),_c('path',{attrs:{"d":"M22.027 11v12.149m0 0L17 18.122m5.027 5.027l5.027-5.027M17 26.5h10.054","stroke":"#3A9CFF","stroke-width":"2","stroke-linecap":"round"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":".25","y":".25","width":"43.5","height":"43.5","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.054902 0 0 0 0 0.298039 0 0 0 0 0.345098 0 0 0 0.1 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    